import C from '../constants';

const showNotification = ({
  notificationPayload,
  notificationTitle,
  notificationDelay = 1000,
  permalink = null,
  id,
  notificationType,
}) => ({
  type: C.SHOW_TOAST,
  notificationPayload,
  notificationTitle,
  notificationDelay,
  notificationType,
  permalink,
  id,
});

const hideNotification = id => ({
  type: C.HIDE_TOAST,
  id,
});

const removeNotification = id => ({
  type: C.REMOVE_TOAST,
  id,
});

export { showNotification, hideNotification, removeNotification };
